import { Title } from "../components/base/Title";
import { Button } from "../components/base/Button";
import { useNavigate } from "react-router-dom";
import { Card } from "components/base/Card";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-container flex flex-col items-center justify-center text-center -my-4"
      style={{
        backgroundImage: 'url(/bg-error.JPG)',
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover"
      }}
    >
      <div className='absolute inset-0 bg-gray-600 opacity-30' />

      <Card className="p-8 flex flex-col items-center justify-center z-10 shadow-sm shadow-primary-100">
        {/* Logo et nom du site */}
        <div className="flex items-center gap-4 mb-6">
          <img src="/404.png" alt="Image 404" className="w-20" />
          <Title type="h1" className="text-8xl font-extrabold text-primary">404</Title>
        </div>

        <Title type="h4" className="mb-6">Oups ! Cette page n'existe pas ou plus.</Title>

        {/* Bouton de retour */}
        <Button
          onClick={() => navigate('/')}
        >
          Retour à l’accueil
        </Button>
      </Card>
    </div>
  );
}
